import { render, staticRenderFns } from "./settingLogin.vue?vue&type=template&id=2cd0049f&scoped=true&"
import script from "./settingLogin.vue?vue&type=script&lang=js&"
export * from "./settingLogin.vue?vue&type=script&lang=js&"
import style0 from "./settingLogin.vue?vue&type=style&index=0&id=2cd0049f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd0049f",
  null
  
)

export default component.exports